import TwitterActivityChart from './TwitterActivityChart.js';
var React = require('react');

const createReactClass = require("create-react-class");


//Dashboard Holds the TwitterActivity Chart Component
//Uses TwitterActivityChart.js
var Dashboard = createReactClass({

    render: function () {
        return (
            <div className="dashboard col-sm-8">
                <TwitterActivityChart
                    binnedTweets={this.props.binnedTweets}
                    totalTweets={this.props.totalTweets}
                    sentiment={this.props.sentiment}
                />
            </div>
        );
    }
});

export default Dashboard;